import { render, staticRenderFns } from "./SaturdayShift.vue?vue&type=template&id=f97ab696&scoped=true"
import script from "./SaturdayShift.vue?vue&type=script&lang=js"
export * from "./SaturdayShift.vue?vue&type=script&lang=js"
import style0 from "./SaturdayShift.vue?vue&type=style&index=0&id=f97ab696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97ab696",
  null
  
)

export default component.exports